export default function dispatcherFactoryService() {
  // permite pasar objetos entre dos controladores/directivas. Se usa en particular para pasar json grandes a directivas de forma mas rapida
  return () => {
    let cache = {};

    return {
      set,
      get: key => cache[key],
      del: key => delete cache[key],
      generateTicket: () => Math.floor(Math.random() * 899999 + 100000),
      destroy: () => (cache = {}),
    };

    // /////////////////////////////////////////////////////////////////////////

    function set(value, key) {
      key = key || value.name || generateTicket();
      cache[key] = value;
      return key;
    }
  };
}
